import { Suspense } from "react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PageHeader } from "@/components/PageHeader";
import { Providers } from "@/components/providers";

export const Route = createFileRoute("/$organizationKey/$dossierId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, dossierId } = Route.useParams();

  return (
    <Providers organizationKey={organizationKey} dossierId={dossierId}>
      <div className="flex flex-col">
        <div className="sticky top-0 z-10">
          <Suspense>
            <PageHeader />
          </Suspense>
        </div>

        <div className="flex-1">
          <Suspense>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </Providers>
  );
}
